import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import SLQuestionOptions from "./SLQuestionOptions";
import { subNumCounting } from "../../../../utils/constants";

const SkipLogic = ({
  isSLDialogVisible,
  setIsSLDialogVisible,
  taskQuestions,
  setSelectedTQIndex,
  selectedTQIndex,
  setTaskquestion,
  onDeleteSkipLogic,
  deleteSlLoading,
  selectedChildQuesIndex = null,
  isSubQuestion = false,
}) => {
  const [selectedTQ] = useState(
    isSubQuestion
      ? taskQuestions[selectedTQIndex]?.subTaskQues[selectedChildQuesIndex]
      : taskQuestions[selectedTQIndex],
  );
  const selectedTQType = selectedTQ?.type || "";
  const [skipToQuesOptions, setSkipToQuesOptions] = useState([]);
  const [selectedSLValues, setSelectedSLValues] = useState([]);
  const [skipLogicQOptions, setSkipLogicQOptions] = useState([]);

  const handleDeleteSkipLogic = async (skipLogicId) => {
    const result = await onDeleteSkipLogic(skipLogicId);

    if (result.success) {
      setSelectedSLValues([]);
      console.log("Success:", result.message);
    } else {
      console.error("Error:", result.message);
    }
  };

  const buildTaskQuestionOption = (
    taskQue,
    index,
    baseIndex,
    customName = null,
  ) => {
    const name =
      customName ||
      `${index + baseIndex}. ${
        taskQue.type === "task"
          ? taskQue.taskName || `Task`
          : taskQue.questionName || `Question`
      }`;

    return {
      name,
      skipToQuestionId:
        taskQue.type === "task"
          ? taskQue?.task_id === 0
            ? taskQue?.tId
            : taskQue?.task_id
          : taskQue?.question_id === 0
            ? taskQue?.qId
            : taskQue?.question_id,
      skip_task_id:
        taskQue?.task_id === 0
          ? taskQue?.tId
          : taskQue?.question_id === 0
            ? taskQue?.tId
            : taskQue?.task_id,
      skip_question_id:
        taskQue?.question_id === 0 ? taskQue?.qId : taskQue?.question_id,
    };
  };

  useEffect(() => {
    const spliceToIndex = isSubQuestion ? selectedTQIndex : selectedTQIndex + 1;
    let taskQuesData = [...taskQuestions.slice(spliceToIndex)];

    // handle randomization skipTo question options for block task/question
    if (!isSubQuestion && (selectedTQ?.bId || selectedTQ?.block_id)) {
      const blockId = selectedTQ?.bId || selectedTQ?.block_id;
      taskQuesData = taskQuesData?.filter(
        (taskQues) =>
          taskQues?.bId === blockId || taskQues?.block_id === blockId,
      );
    }
    // handle randomization skipTo question options for task subquestions
    if (isSubQuestion) {
      const selectParentTQ = taskQuestions[selectedTQIndex];
      if (selectParentTQ?.bId || selectParentTQ?.block_id) {
        const blockId = selectParentTQ?.bId || selectParentTQ?.block_id;
        taskQuesData = taskQuesData?.filter(
          (taskQues) =>
            taskQues?.bId === blockId || taskQues?.block_id === blockId,
        );
      }
    }

    // handle randomization skipTo question options for non-block task/question
    if (!isSubQuestion && !selectedTQ?.bId && !selectedTQ?.block_id) {
      taskQuesData = taskQuesData?.filter(
        (taskQues) => !taskQues?.bId && !taskQues?.block_id,
      );
    }

    // handle randomization skipTo question options for non-block sub task-question
    if (isSubQuestion) {
      const selectParentTQ = taskQuestions[selectedTQIndex];
      if (!selectParentTQ?.bId || !selectParentTQ?.block_id) {
        taskQuesData = taskQuesData?.filter(
          (taskQues) => !taskQues?.bId && !taskQues?.block_id,
        );
      }
    }
    const taskQuesDataOpts = taskQuesData.flatMap((taskQue, i) => {
      const itemIndex = [...taskQuestions.slice(spliceToIndex)]?.findIndex(
        (data) => data?.tId === taskQue?.tId,
      );
      const baseIndex = spliceToIndex + 1 + itemIndex;
      // If task has subTaskQues, only return sub-questions (no parent)
      if (taskQue.type === "task" && taskQue?.subTaskQues?.length > 0) {
        return taskQue.subTaskQues
          .slice(i === 0 && isSubQuestion ? selectedChildQuesIndex + 1 : 0)
          .map((subItem, subIndex) => {
            const subQue = { ...subItem };
            const customName = `${baseIndex}${subNumCounting[i === 0 && isSubQuestion ? selectedChildQuesIndex + 1 + subIndex : subIndex]}. ${subQue.questionName || "Sub Question"}`;
            return buildTaskQuestionOption(subQue, 0, 0, customName);
          });
      } else {
        // For other types without subTaskQues, return the parent
        return [buildTaskQuestionOption(taskQue, baseIndex, 0)];
      }
    });
    const allCompleted = [
      {
        name: "You have completed all Tasks/Questions",
        skipToQuestionId: "1",
        skip_task_id: "end_session",
        skip_question_id: "end_session",
      },
    ];
    setSkipToQuesOptions([...taskQuesDataOpts, ...allCompleted]);

    if (selectedTQ?.skipLogic?.length) {
      setSelectedSLValues(selectedTQ?.skipLogic || []);
      setSkipLogicQOptions(selectedTQ?.skipLogic || []);
    }
  }, [selectedTQIndex]);

  const onSaveClick = () => {
    if (
      selectedTQType === "task" ||
      (selectedTQType === "question" &&
        selectedTQ?.selectedQuestionOption === "open_ended_question")
    ) {
      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i === selectedTQIndex) {
            if (isSubQuestion) {
              return {
                ...prevProp,
                subTaskQues: prevProp.subTaskQues.map((subTask, subIndex) => {
                  if (subIndex === selectedChildQuesIndex) {
                    return {
                      ...subTask,
                      skipLogic: selectedSLValues,
                    };
                  }
                  return subTask;
                }),
              };
            }
            return { ...prevProp, skipLogic: selectedSLValues };
          }
          return prevProp;
        }),
      );
    } else {
      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i === selectedTQIndex) {
            const filteredSkipLogic = skipLogicQOptions.filter(
              (data) =>
                data?.selectedOptions &&
                data?.selectedOptions.length &&
                data?.skipToQuestionId &&
                (selectedTQ?.selectedQuestionOption !== "ranking_question" ||
                  data?.selectedRank),
            );
            if (isSubQuestion) {
              return {
                ...prevProp,
                subTaskQues: prevProp.subTaskQues.map((subTask, subIndex) => {
                  if (subIndex === selectedChildQuesIndex) {
                    return {
                      ...subTask,
                      skipLogic: filteredSkipLogic,
                    };
                  }
                  return subTask;
                }),
              };
            }
            return {
              ...prevProp,
              skipLogic: filteredSkipLogic,
            };
          }
          return prevProp;
        }),
      );
    }

    if (!isSLDialogVisible) return;
    setIsSLDialogVisible(false);
    setSelectedTQIndex(null);
  };
  // console.log("skip", taskQuestions);
  // console.log("skip", skipToQuesOptions);
  // console.log("selectedSLValues", selectedSLValues);
  return (
    <>
      <div className="m-0 pt-4">
        <div className="p-3 mt-4" style={{ backgroundColor: "#f5f5f5" }}>
          <div className="row">
            {selectedTQType === "task" ||
            (selectedTQType === "question" &&
              selectedTQ?.selectedQuestionOption === "open_ended_question") ? (
              <>
                <div className="col-12">
                  <label>Skip to:</label>
                  <Dropdown
                    value={
                      selectedSLValues.length > 0
                        ? selectedSLValues[0]?.skipToQuestionId
                        : ""
                    }
                    onChange={(e) => {
                      // let skipToQuestionJson = { ...e.value };
                      // delete skipToQuestionJson?.skip_logic_id;
                      const targetValue = e.value;
                      const selectedOption = skipToQuesOptions?.find(
                        (skipLogicQOption, i) =>
                          skipLogicQOption?.skipToQuestionId === targetValue,
                      );
                      if (selectedSLValues?.length > 0) {
                        setSelectedSLValues((prev) =>
                          prev.map((item, i) =>
                            i === 0 ? { ...item, ...selectedOption } : item,
                          ),
                        );
                      } else {
                        setSelectedSLValues([{ ...selectedOption }]);
                      }
                    }}
                    options={skipToQuesOptions}
                    optionLabel="name"
                    optionValue="skipToQuestionId"
                    placeholder="Skip To Question"
                    className="w-100 inputField modal-dropdown"
                    appendTo="self"
                  />
                </div>
                {selectedSLValues.length ? (
                  <div className="text-end">
                    <Button
                      className="bulk-add fw-bold fs-14 px-0 mb-3"
                      disabled={deleteSlLoading}
                      link
                      onClick={() => {
                        const selectedSLValue = selectedSLValues[0];
                        if (
                          selectedSLValue?.skip_logic_id &&
                          selectedSLValue?.skip_logic_id !== 0
                        ) {
                          handleDeleteSkipLogic(selectedSLValue?.skip_logic_id);
                        } else {
                          setSelectedSLValues([]);
                        }
                      }}
                    >
                      - Remove skip logic
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              <SLQuestionOptions
                selectedTQ={selectedTQ}
                selectedTQIndex={selectedTQIndex}
                skipToQuesOptions={skipToQuesOptions}
                selectedTQAnswerOpts={
                  selectedTQ[selectedTQ?.selectedQuestionOption]?.options || []
                }
                selectedSLValues={selectedSLValues}
                setSelectedSLValues={setSelectedSLValues}
                setSkipLogicQOptions={setSkipLogicQOptions}
                skipLogicQOptions={skipLogicQOptions}
                deleteSlLoading={deleteSlLoading}
                onDeleteSkipLogic={onDeleteSkipLogic}
              />
            )}
          </div>
        </div>
      </div>

      <div className="mt-auto d-flex justify-content-end gap-2 pt-5">
        <Button
          label="Cancel"
          className="px-4 py-2 fw-bold cancel"
          onClick={() => {
            if (!isSLDialogVisible) return;
            setIsSLDialogVisible(false);
            setSelectedTQIndex(null);
          }}
        />

        <Button
          label="Save"
          className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
          onClick={onSaveClick}
        />
      </div>
    </>
  );
};

export default SkipLogic;
